import { render, staticRenderFns } from "./BtnGoBottom.vue?vue&type=template&id=7b8c97c7&"
import script from "./BtnGoBottom.vue?vue&type=script&lang=js&"
export * from "./BtnGoBottom.vue?vue&type=script&lang=js&"
import style0 from "./BtnGoBottom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports